import { Modalable, ResponseStatus } from './modalable';

export class ModalableDigbi implements Modalable {
    static MODAL_ID = 'digbiModal';
    bypass = true;

    status: ResponseStatus;
    storeUrl: string;
    contentUrl: string;
    isTeacher = false;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getModalId(): string {
        return ModalableDigbi.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypass;
    }
}
